import { render, staticRenderFns } from "./choose-package-dialog.vue?vue&type=template&id=3465c6a2&"
import script from "./choose-package-dialog.vue?vue&type=script&lang=js&"
export * from "./choose-package-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports